import { createContext, useContext } from "react";
import type { AccountController, AccountState } from "./accountController";
export const AccountContext = createContext<{ controller: AccountController; state: AccountState } | null>(null);
export function useAccount() { return useContext(AccountContext); }
